export default __webpack_public_path__ + "static/media/no-active-offers.487454d0.svg";